import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import ErrorMessage from '@/components/common/ErrorMessage';
import FieldLayout from '@/components/Layout/FieldLayout';
import Button from '@/components/ui/Button';
import Label from '@/components/ui/Label';
import PrimaryInput from '@/components/ui/PrimaryInput';
import {
  IAddEmployeeForm,
  IEmployeeOnBoardResponse,
} from '@/interfaces/employee.model';
import { relationTypes, showToastNotification } from '@/utility/helper';
import { errorTypes } from '@/utility/validation';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
interface IEmployeeNomineeDetailsStep6Props {
  nextStep: () => void;
  empId: string | null;
}
const EmployeeNomineeDetailsStep6 = ({
  nextStep,
  empId,
}: IEmployeeNomineeDetailsStep6Props) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const {
    register,
    trigger,
    getValues,
    formState: { errors },
  } = useFormContext<IAddEmployeeForm>();
  const handleNextStep = async () => {
    const isValid = await trigger([
      'nomineeRelation',
      'nomineeName',
      'nomineePhone',
      'nomineeDob',
    ]);

    if (isValid && empId) {
      setIsLoading(true);
      const formData = new FormData();
      const data = getValues();
      formData.append('nomineeRelation', data?.nomineeRelation);
      formData.append('nomineeName', data?.nomineeName);
      formData.append('nomineePhone', data?.nomineePhone);
      formData.append('nomineeDob', data?.nomineeDob);
      try {
        const response: IEmployeeOnBoardResponse = await callApi(
          API_URL + API_ENDPOINT.addEmployee + `?userId=${empId}`,
          { method: 'POST', data: formData, multipart: true },
        );
        if (response?.status) {
          showToastNotification('success', response?.message);
          nextStep();
        }
      } catch (error) {
        if (error && typeof error === 'object' && 'message' in error) {
          showToastNotification('danger', (error as IApiErrorResponse).message);
        } else {
          showToastNotification('danger', 'Something went wrong');
        }
      } finally {
        setIsLoading(false);
      }
    }
  };
  return (
    <>
      <div className="row">
        <div className="col-12">
          <h4 className="fs-3 rajdhani-semibold my-4 border-bottom pb-3">
            Family Details
          </h4>
        </div>
        <div className="col-12 col-md-6 col-lg-4">
          <div className="form-group mb-3">
            <Label id="nomineeRelation" required={true}>
              Relation Type
            </Label>
            <select
              className="form-select form-control"
              aria-label="Default select example"
              {...register('nomineeRelation', {
                required: 'This field is Required',
              })}
            >
              <option value="" className="d-none">
                Select relation Type
              </option>
              {relationTypes?.map((relation) => (
                <option value={relation}>{relation}</option>
              ))}
            </select>
            <ErrorMessage message={errors?.nomineeRelation?.message} />
          </div>
        </div>
        <FieldLayout fieldStyle=" col-lg-4">
          <PrimaryInput
            id="Name"
            placeholder="Enter name"
            errors={errors?.nomineeName?.message}
            required={true}
            label="Nominee Name"
            {...register('nomineeName', {
              required: 'This field is Required',
              ...errorTypes.name,
            })}
          />
        </FieldLayout>
        <FieldLayout fieldStyle=" col-lg-4">
          <PrimaryInput
            type="number"
            errors={errors?.nomineePhone?.message}
            required={true}
            label="Phone No."
            id="Number"
            placeholder="Enter number"
            {...register('nomineePhone', {
              required: 'This field is Required',
              ...errorTypes.phone,
            })}
          />
        </FieldLayout>
        <FieldLayout fieldStyle=" col-lg-4">
          <PrimaryInput
            type="date"
            errors={errors?.nomineeDob?.message}
            required={true}
            label="Date of Birth"
            id="Datebirth"
            max={new Date().toISOString().split('T')[0]}
            {...register('nomineeDob', {
              required: 'This field is Required',
            })}
          />
        </FieldLayout>
      </div>
      <div className="d-flex align-items-center justify-content-end">
        <Button
          className="btn btn-primary px-4"
          type="button"
          isLoading={isLoading}
          onClick={handleNextStep}
        >
          Save and Continue
        </Button>
      </div>
    </>
  );
};
export default EmployeeNomineeDetailsStep6;
